
import { emitEvent } from '../../utils/eventBus/vueEvent'
import Events from '../events/index'

let origin = location.origin;

export const setPostOrigin = (org) => {
  console.log('--setPostOrigin-:', org);
  if (org && (org.endsWith('myqcloud.com') || org.endsWith('qq.com')))
    origin = org
}

export const sendToPythonIframe = (event) => {
  console.log('- message to python: ', event.method)
  window.frames['pythonRunIframe'].postMessage(event, origin);
};

export const sendToIdeIframe = (event) => {
  console.log('- message to ide: ', event.method, event)
  window.frames['ideIframe'].postMessage(event, origin);
};

export default {
  setIdeCode: (code, isLocalIde) => {
    if (isLocalIde) {
      emitEvent(Events.IDE_SET_CODE, code)
      return
    }
    sendToIdeIframe({
      method: 'ide_set_code',
      data: code
    });
  },

  getIdeCode: (type, isLocalIde) => {
    if (isLocalIde) {
      emitEvent(Events.IDE_GET_CODE, type)
    } else {
      sendToIdeIframe({
        method: 'ide_get_code',
        type,
      });
    }
  },

  setIdeTheme: (theme, isLocalIde) => {
    if (isLocalIde) {
      emitEvent(Events.IDE_SET_THEME, theme)
      return
    }
    sendToIdeIframe({
      method: 'ide_set_theme',
      data: theme,
    });
  },

  runPythonLocal: code => {
    sendToPythonIframe({
      method: 'python_run_code',
      data: code
    });
  },

  inputPythonLocal: (input, isPyRuntimeCom) => {
    if (isPyRuntimeCom) {
      emitEvent(Events.PYTHON_SET_INPUT, input)
      return
    }
    sendToPythonIframe({
      method: 'python_set_input',
      data: input
    });
  },

  TYPE_RUN: 'run',
  TYPE_TEST: 'test',
  TYPE_TEST_HTTP: 'test_http',
  TYPE_SAVE: 'save',
  TYPE_CACHE_SAVE: 'save_cache',
  TYPE_CLOSE_SAVE: 'save_close',
  TYPE_AUTO_SAVE: 'auto_save',
  TYPE_COMMIT: 'commit',
  YOUTH_SET_CODE: 'youth_set_code',

  // iframe event:
  CLOSEWINDOWS: 'closeWindows',
  PYTHON_READY: 'python_ready',
  IDE_READY: 'ide_ready',
  IDE_EDIT_BLUR: 'ide_edit_blur',
  IDE_EDIT_CHANGE: 'ide_edit_change',
  PYTHON_RUN_RES: 'python_run_res',
  PYTHON_RUN_END: 'python_run_end',
  YOUTH_OUTPUT: 'youth_output',
  YOUTH_GET_INPUT: 'youth_get_input',
};
